/** Mirrors CPHub.Data.Models.AllergyType — how a GSDD patient allergy was recorded. */
export enum AllergyType {
    Class = 0,
    Ingredient = 1,
    Drug = 2,
}

/** One conflict between a selected drug and the patient's recorded allergies. */
export interface AllergyScreeningMatch {
    /** How the patient recorded the matching allergy (class, ingredient, or a specific drug). */
    allergyType: AllergyType;
    /** GSDD concept the drug matched on, e.g. "Sulfonamides". Always populated. */
    matchedOn: string;
    /** Allergy name as it reads on the patient's profile; null when the hit has no profile row. */
    patientAllergyName: string | null;
    /** Reaction recorded on the patient's profile, when they gave one. */
    reaction: string | null;
    /** Compound ingredient responsible for the hit; null when the drug matched directly. */
    ingredientName: string | null;
}

export interface AllergyScreeningResult {
    /**
     * Whether screening actually ran. False means no conclusion was reached (NonGSDD product, a compound with
     * no GSDD ingredients, or a GSDD failure) and must never be shown as "no allergy conflict" — the warning
     * component renders a distinct un-screened note for it rather than staying silent.
     */
    calculated: boolean;
    matches: AllergyScreeningMatch[];
}
